import ProdFeature from './ProdFeature';
export default ProdFeature;
